import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { PagePath } from './navigation.enums';
import { ArticlePage } from '../pages/articles/article.page';
import { QuestionsPage } from '../pages/questions/questions';
import { RolesPage } from '../pages/roles/roles.page';
import { RolePage } from '../pages/roles/view-role/role.page';
import { SkillsPage } from '../pages/skills/skills.page';
import { SkillPage } from '../pages/skill/skill.page';

export function MainRouter(): JSX.Element {
  return (
    <Routes>
      <Route path={PagePath.role} element={<RolePage />} />
      <Route path={PagePath.roles} element={<RolesPage />} />
      <Route path={PagePath.skills} element={<SkillsPage />} />
      <Route path={PagePath.skill} element={<SkillPage />} />
      <Route path={PagePath.article} element={<ArticlePage />} />
      <Route path={PagePath.questions} element={<QuestionsPage />} />
      <Route path={PagePath.home} element={<RolesPage />} />
    </Routes>
  );
}